import React from 'react'

function SvgHelpIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      fill="none"
      viewBox="0 0 13 12"
      {...props}
    >
      <g clipPath="url(#clip0_10322_105821)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.333"
          d="M4.713 4.5a1.5 1.5 0 012.915.5c0 1-1.5 1.5-1.5 1.5m.04 2h.005M11.168 6a5 5 0 11-10 0 5 5 0 0110 0z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_10322_105821">
          <path
            fill="#fff"
            d="M0 0H12V12H0z"
            transform="translate(.168)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgHelpIcon
